import { useContext, } from 'react';
import { Field, Panel } from '../../../../layouts';
import { PurchaseOrderContext } from '../../purchase-order/context/PurchaseOrderContext';

export default function CreditMemoBillToPanel() {

	const { order } = useContext(PurchaseOrderContext);

	return (
		<>
			<Panel
				header={'Bill To'}
				className="field-label-30"
			>
				<Field label={'Company'} >{order.details.distributor.companyName}</Field>
				<Field label={'Address'} >{order.details.distributor.PA_Address1}</Field>
				<Field label={''} visible={!!order.details.distributor.PA_Address2}>{order.details.distributor.PA_Address2}</Field>
				<Field label={'City'} >{order.details.distributor.PA_City}, {order.details.distributor.PA_State} {order.details.distributor.PA_Zip}</Field>
			</Panel>
		</>
	);
}
